// extracted by mini-css-extract-plugin
export default {"buttonSubmit":"style_buttonSubmit__OCuJw","disable":"style_disable__r0I3o","MainDiv":"style_MainDiv__NLUIK","attachTextArea":"style_attachTextArea__qf4UC"};